import {inlineError} from '@s-ui/decorators'

import UserRepository from './UserRepository.js'

export class EmptyUserRepository extends UserRepository {
  /**
   * @class
   * @implements UserRepository
   */

  @inlineError
  getContactToken = () => {
    Promise.resolve()
  }

  @inlineError
  saveContactToken = ({contactTokenValueObject}) => {
    Promise.resolve()
  }
}
